import React, { FC } from "react";
import { ContactPage } from "./Pages/ContactPage";
import { InsuranceFiltersContext } from "./Utils/Context/filtersContext";
import { InsuranceLabelsContext } from "./Utils/Context/labelsContext";
import { ContactFormParams } from "../../Pages/ContactForm/ContactFormParams.csharp";

export const InsuranceContact: FC<ContactFormParams> = (props) => {
  return (
    <InsuranceLabelsContext labels={props.insuranceLabels}>
      <InsuranceFiltersContext>
        <ContactPage {...props} />
      </InsuranceFiltersContext>
    </InsuranceLabelsContext>
  );
};
